export const CompletedProjectsImageStructure = {
  images: {
    name: "Image",
    type: "multi-image",
    index: 0,
  },
};
